import React from 'react';
import Icon from './Icon';

export default class View extends Icon {
  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="23"
      viewBox="0 0 40 23"
    >
      <path
        fill="#485465"
        fillRule="evenodd"
        d="M20 18.688c-4.073 0-7.273-3.163-7.273-7.188s3.2-7.188 7.273-7.188c4.073 0 7.273 3.163 7.273 7.188s-3.2 7.188-7.273 7.188m0 1.437c6.69 0 12.8-3.162 16.582-8.625C32.8 6.038 26.69 2.875 20 2.875c-6.69 0-12.8 3.163-16.582 8.625C7.2 16.963 13.31 20.125 20 20.125zM.218 12.362c-.29-.575-.29-1.15 0-1.437C4.582 4.025 11.855 0 20 0s15.418 4.025 19.782 10.638c.29.575.29 1.15 0 1.437C35.418 18.975 28.145 23 20 23S4.582 18.975.218 12.362z"
      />
    </svg>
  );
}
